import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import '../media/Img.js';
import { Icon } from '../media/Icon.js';
import { Box } from '../layout/Box.js';
import { Stack } from '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
import '../typography/Text.js';
import '../typography/Display.js';
import { Heading } from '../typography/Heading.js';
import '../typography/Label.js';
import '../typography/Paragraph.js';
import React__default from 'react';
import styled from 'styled-components';
import { usePopoverContext } from './PopoverContext.js';
var StyledContainer = styled(Box)(css({
  px: "16px",
  height: "48px",
  minWidth: "326px",
  display: "flex",
  alignItems: "center",
  borderRadius: "8px",
  transition: "background-color 200ms",
  cursor: "pointer",
  ":hover": {
    backgroundColor: "background"
  }
}));
var PopoverItem = function PopoverItem(_a) {
  var icon = _a.icon,
    children = _a.children,
    onClick = _a.onClick,
    _b = _a.closeOnClick,
    closeOnClick = _b === void 0 ? true : _b,
    rest = __rest(_a, ["icon", "children", "onClick", "closeOnClick"]);
  var onClose = usePopoverContext().onClose;
  var handleClick = function handleClick(e) {
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
    if (closeOnClick) {
      onClose();
    }
  };
  return React__default.createElement(StyledContainer, __assign({}, rest, {
    onClick: handleClick
  }), React__default.createElement(Stack, {
    spacing: "12px",
    align: "center"
  }, icon && (typeof icon === "string" ? React__default.createElement(Icon, {
    icon: icon,
    fontSize: "24px"
  }) : icon), React__default.createElement(Heading, {
    size: "sm"
  }, children)));
};
export { PopoverItem };